const APP_CONFIG = {
  loadingDuration: 2500,
};

export default APP_CONFIG;
